/* eslint-disable react/display-name */
import React, { useState, useMemo } from 'react';
import { DateTime } from 'luxon';
import { DateRangeOptionType } from '../type';
import { SearchBoxProps } from '../type';
import { DateCriterionType } from './DateRangeFacetDetails';

const matchOption = (_: [], term: string): DateRangeOptionType | null => {
  if (!term) return null;
  const option = term.split('+')[1];

  if (option) {
    return {
      value: DateTime.fromISO(option),
      key: term
    };
  }

  return null;
};

const withCriteriaProvider = (
  tag: string,
  context: React.Context<DaterangeCriteriaProviderContextType>
) => (
  BaseComponent: React.FunctionComponent<SearchBoxProps>
): React.FC<SearchBoxProps> => (props: SearchBoxProps) => {
  const { searchCriteria: { criterions = {} } = {} } = props;
  const [selected, setSelected] = useState<DateCriterionType[]>(
    (criterions[tag] as DateCriterionType[]) || []
  );

  const value = useMemo(
    () => ({
      selected,
      matchOption,
      setSelected
    }),
    [selected, setSelected]
  );

  return (
    <context.Provider value={value}>
      <BaseComponent {...props} />
    </context.Provider>
  );
};

type DaterangeCriteriaProviderContextType = {
  selected: DateCriterionType[];
  setSelected: React.Dispatch<React.SetStateAction<DateCriterionType[]>>;
  matchOption: (_: [], term: string) => DateRangeOptionType | null;
};

const makeCriteriaProvider = (
  tag: string,
  context: React.Context<DaterangeCriteriaProviderContextType>
): ((
  BaseComponent: React.FunctionComponent<SearchBoxProps>
) => React.FC<SearchBoxProps>) => withCriteriaProvider(tag, context);

export default makeCriteriaProvider;
